import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 30000,
});

export function fmtErr(detail) {
  if (detail == null) return "Errore sconosciuto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" • ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
